import { Component } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { CLASS_ACTIVE, CLASS_EMPTY } from '../../../shared-third-party/consts';
import { HeaderService } from '../header.service';

interface ISubMenuMapItem {
  open: boolean;
  subMenu: ISubMenuItem[][];
}

export interface ISubMenuItem {
  title: string;
  href: string;
  bold: boolean;
}
export interface IMenuItem {
  title: string;
  href: string;
  id: string;
  isOnly?: boolean|null;
}

@Component({
  selector: 'app-header-bottom',
  templateUrl: './header-bottom.component.html',
  styleUrl: './header-bottom.component.scss'
})
export class HeaderBottomComponent {

  commonMenu: IMenuItem[] = [
    {
      title: 'Квартиры',
      href: '/kupit-kvartiru-all',
      id: 'all',
    },
    {
      title: 'Новостройки',
      href: '/novostrojki',
      id: 'newbuilding',
    },
    {
      title: 'Вторичка',
      href: '/kupit-kvartiru/flats#noscroll',
      id: 'resale'
    },
    {
      title: 'Коммерческая',
      href: 'commercial/#noscroll',
      id: 'commercial'
    },
    {
      title: 'Застройщикам',
      href: '/zastrojshhikam',
      id: 'zastrojshhikam'
    },
    {
      title: 'Подбор квартиры',
      href: '/podbor',
      isOnly: true,
      id: 'cottage'
    },
    {
      title: 'Ипотека',
      href: '/ipoteka',
      id: 'mortgage'
    },
    {
      title: 'Консалтинг',
      isOnly: true,
      href: '/konsalting-i-analitika',
      id: 'zastrojsshikam'
    },
    {
      title: 'Контакты',
      isOnly: true,
      href: '/kontakty',
      id: 'services'
    },];

  allMenuItems: ISubMenuItem[][] = [
    [
      {
        'title': 'Все квартиры',
        'href': "/kupit-kvartiru-all/",
        'bold': true,
      },
      {
        'title': 'Квартиры в новостройке',
        'href': "/kupit-kvartiru-all/new'})",
        'bold': true,
      },
      {
        'title': 'Квартиры во вторичке',
        'href': "/kupit-kvartiru-all/resale",
        'bold': true,
      },
      {
        'title': 'Акции и скидки',
        'href': "/novostrojki/akcii-i-skidki",
        'bold': false,
      },
    ],
    [
      {
        'title': 'Квартиры студии',
        'href': "/kupit-kvartiru-all/all/room-studio",
        'bold': false,
      },
      {
        'title': '1-комнатные квартиры',
        'href': "/kupit-kvartiru-all/all/room-1",
        'bold': false,
      },
      {
        'title': '2-комнатные квартиры',
        'href': "/kupit-kvartiru-all/all/room-2",
        'bold': false,
      },
      {
        'title': '3-комнатные квартиры',
        'href': "/kupit-kvartiru-all/all/room-3",
        'bold': false,
      },
      {
        'title': '4-комнатные квартиры',
        'href': "/kupit-kvartiru-all/all/room-4-plus",
        'bold': false,
      },
      {
        'title': 'Квартиры в Москве',
        'href': "/kupit-kvartiru-all/all/r-moskva",
        'bold': false,
      },
      {
        'title': 'Квартиры в Подмосковье',
        'href': "/kupit-kvartiru-all/all/r-moskovskaya-oblast",
        'bold': false,
      },

    ],
    [
      {
        'title': 'Квартиры в Новой Москве',
        'href': "/kupit-kvartiru-all/all/o-novomoskovskij",
        'bold': false,
      },
      {
        'title': 'Квартиры у метро',
        'href': "/kupit-kvartiru-all/all/near-subway",
        'bold': false,
      },
      {
        'title': 'Квартиры в центре Москвы',
        'href': "/kupit-kvartiru-all/all/o-centralnyj",
        'bold': false,
      },
      {
        'title': 'Квартиры на севере Москвы',
        'href': "/kupit-kvartiru-all/all/o-severnyj",
        'bold': false,
      },
      {
        'title': 'Квартиры на юге Москвы',
        'href': "/kupit-kvartiru-all/all/o-yuzhnyj",
        'bold': false,
      },
      {
        'title': 'Квартиры на западе Москвы',
        'href': "/kupit-kvartiru-all/all/o-zapadnyj",
        'bold': false,
      },
      {
        'title': 'Квартиры на востоке Москвы',
        'href': "/kupit-kvartiru-all/all/o-vostochnyj",
        'bold': false,
      },
    ],
  ];

  subMenuNewBuildingsItems: ISubMenuItem[][] = [
    [
      {
        'title': 'Жилые комплексы',
        'href': "/novostrojki#noscroll",
        'bold': true,
      },
      {
        'title': 'Новостройки Москвы',
        'href': "/novostrojki/r-moskva#noscroll",
        'bold': true,
      },
      {
        'title': 'Новостройки Новой Москвы',
        'href': "/novostrojki/o-novomoskovskij#noscroll",
        'bold': true,
      },
      {
        'title': 'Новостройки Подмосковья',
        'href': "/novostrojki/r-moskovskaya-oblast#noscroll",
        'bold': true,
      },
      {
        'title': 'Новостройки Ленинградской обл',
        'href': "/novostrojki/r-leningradskaya-oblast#noscroll",
        'bold': true,
      },
      {
        'title': 'Акции и скидки',
        'href': "/novostrojki/akcii-i-skidki",
        'bold': true,
      },
    ],
    [
      {
        'title': 'Квартиры студии',
        'href': "/novostrojki/room-studio",
        'bold': false,
      },
      {
        'title': '1-комнатные квартиры',
        'href': "/novostrojki/room-1",
        'bold': false,
      },
      {
        'title': '2-комнатные квартиры',
        'href': "/novostrojki/room-2",
        'bold': false,
      },
      {
        'title': '3-комнатные квартиры',
        'href': "/novostrojki/room-3",
        'bold': false,
      },
      {
        'title': '4-комнатные квартиры',
        'href': "/novostrojki/room-4-plus",
        'bold': false,
      },
      {
        'title': 'Новостройки рядом с метро',
        'href': "/novostrojki/near-subway#noscroll",
        'bold': false,
      },
    ],
    [
      {
        'title': 'Сданные новостройки',
        'href': "/novostrojki/ready#noscroll",
        'bold': false,
      },
      {
        'title': 'Новостройки с отделкой',
        'href': "/novostrojki/with-finishing#noscroll",
        'bold': false,
      },
      {
        'title': 'Новостройки без отделки',
        'href': "/novostrojki/without-finishing#noscroll",
        'bold': false,
      },
      {
        'title': 'Новостройки комфорт класса',
        'href': "/novostrojki/comfort#noscroll",
        'bold': false,
      },
      {
        'title': 'Новостройки бизнес класса',
        'href': "/novostrojki/business'#noscroll",
        'bold': false,
      },
      {
        'title': 'Новостройки премиум класса',
        'href': "/novostrojki/premium#noscroll",
        'bold': false,
      },
    ],
  ];

  subMenuResaleItems: ISubMenuItem[][] = [
    [
      {
        'title': 'Вторичная недвижимость',
        'href': "/kupit-kvartiru/flats#noscroll",
        'bold': true,
      },
      {
        'title': 'Квартиры в Москве',
        'href': "/kupit-kvartiru/flats/r-moskva#noscroll",
        'bold': true,
      },
      {
        'title': 'Квартиры в Новой Москве',
        'href': "/kupit-kvartiru/flats/o-novomoskovskij#noscroll",
        'bold': true,
      },
      {
        'title': 'Квартиры в Подмосковье',
        'href': "/kupit-kvartiru/flats/r-moskovskaya-oblast#noscroll",
        'bold': true,
      },
      {
        'title': 'Акции и скидки',
        'href': "/kupit-kvartiru/akcii-i-skidki",
        'bold': true,
      },
    ],
    [
      {
        'title': 'Квартиры студии',
        'href': "/kupit-kvartiru/flats/room-studio#noscroll",
        'bold': false,
      },
      {
        'title': '1-комнатные квартиры',
        'href': "/kupit-kvartiru/flats/room-1#noscroll",
        'bold': false,
      },
      {
        'title': '2-комнатные квартиры',
        'href': "/kupit-kvartiru/flats/room-2#noscroll",
        'bold': false,
      },
      {
        'title': '3-комнатные квартиры',
        'href': "/kupit-kvartiru/flats/room-3#noscroll",
        'bold': false,
      },
      {
        'title': '4-комнатные квартиры',
        'href': "/kupit-kvartiru/flats/kupit-kvartiru/room-4-plus#noscroll",
        'bold': false,
      },
    ],
    [
      {
        'title': 'Покупка квартиры',
        'href': "/kupit-kvartiru/kupit",
        'bold': false,
      },
      {
        'title': 'Продать квартиру',
        'href': "/kupit-kvartiru/prodat",
        'bold': false,
      },
      {
        'title': 'Обменять квартиру',
        'href': "/kupit-kvartiru/obmen",
        'bold': false,
      },
      {
        'title': 'Оценка квартиры',
        'href': "/kupit-kvartiru/ocenka",
        'bold': false,
      },
      {
        'title': 'Сопровождение сделки',
        'href': "/kupit-kvartiru/soprovozhdenie-sdelki",
        'bold': false,
      },
    ],
  ];

  subMenuCommercialItems: ISubMenuItem[][] = [
    [
      {
        'title': 'Коммерческая недвижимость ',
        'href': "/commercial/#noscroll",
        'bold': true,
      },
      {
        'title': 'Недвижимость в Москве',
        'href': "/commercial/sale/r-moskva#noscroll",
        'bold': true,
      },
      {
        'title': 'Недвижимость в Новой Москве',
        'href': "/commercial/all/sale/o-novomoskovskij",
        'bold': true,
      },
      {
        'title': 'Недвижимость в Подмосковье',
        'href': "/commercial/sale/r-moskovskaya-oblast#noscroll",
        'bold': true,
      },
    ],
    [
      {
        'title': 'Продажа недвижимости',
        'href': "/commercial/sale#noscroll",
        'bold': false,
      },
      {
        'title': 'Аренда недвижимости',
        'href': "/commercial/rent/commercial/#noscroll",
        'bold': false,
      },
    ],
    [
      {
        'title': 'Торговые помещения',
        'href': "/commercial/all/shop/sale#noscroll",
        'bold': false,
      },
      {
        'title': 'Офисы',
        'href': "/commercial/all/office/sale#noscroll",
        'bold': false,
      },
      {
        'title': 'Помещения свободного назначения',
        'href': "/commercial/all/other/sale/#noscroll",
        'bold': false,
      },
    ]
  ];

  subMenuCottageItems: ISubMenuItem[][] = [
    [
      {
        'title': 'Загородная недвижимость',
        'href': "/zagorodnaya-nedvizhimost/",
        'bold': true,
      },
      {
        'title': 'Коттеджные поселки',
        'href': "/zagorodnaya-nedvizhimost/village/",
        'bold': true,
      },
    ],
    [
      {
        'title': 'Дома',
        'href': "/zagorodnaya-nedvizhimost/house",
        'bold': false,
      },
      {
        'title': 'Участки',
        'href': "/zagorodnaya-nedvizhimost/land",
        'bold': false,
      },
    ],
    [
      {
        'title': 'Продать',
        'href': "/zagorodnaya-nedvizhimost/prodazha",
        'bold': false,
      },
      {
        'title': 'Купить',
        'href': "/zagorodnaya-nedvizhimost/pokupka",
        'bold': false,
      },
      {
        'title': 'Сопровождение',
        'href': "/zagorodnaya-nedvizhimost/soprovozhdenie",
        'bold': false,
      },
    ]
  ];

  subMenuMortgageItems: ISubMenuItem[][] = [
    [
      {
        'title': 'Ипотека',
        'href': "/ipoteka",
        'bold': true,
      },
      {
        'title': 'Рефинансирование',
        'href': "/ipoteka/refinansirovanie",
        'bold': true,
      },
    ],
    [
      {
        'title': 'Военная ипотека',
        'href': "/ipoteka/voennaya",
        'bold': false,
      },
      {
        'title': 'Семейная ипотека',
        'href': "/ipoteka/materinskij-kapital",
        'bold': false,
      },
      {
        'title': 'Господдержка',
        'href': "/ipoteka/s-gospodderzhkoj",
        'bold': false,
      },
    ],
    [
      {
        'title': 'Вопросы и ответы',
        'href': "/ipoteka/chasto-zadavaemye-voprosy",
        'bold': false,
      },
    ]
  ];

  subMenuAboutCompanyItems: ISubMenuItem[][] = [
    [
      {
        'title': 'Online сделки',
        'href': "/online-deal",
        'bold': true,
      },
      {
        'title': 'Способы оплаты',
        'href': "/sposoby-oplaty",
        'bold': true,
      },
      {
        'title': 'Центральный офис',
        'href': "/kontakty/centralnyj-ofis",
        'bold': true,
      },
      {
        'title': 'Отзывы',
        'href': "/otzyvy",
        'bold': true,
      },
      {
        'title': 'Вакансии',
        'href': "/vacancies",
        'bold': true,
      },
    ]
  ];

  // вот тут странно, на проде на ссылке Контакты нет выпадающего меню
  subMenuServicesItems: ISubMenuItem[][] = [
    [
      {
        'title': 'Проверка объектов и субъектов',
        'href': '#',
        'bold': true,
      },
      {
        'title': 'Проверка ликвидности',
        'href': '#',
        'bold': true,
      },
      {
        'title': 'Подбор инвест проектов',
        'href': '#',
        'bold': true,
      },
    ],
    [
      {
        'title': 'Продажа',
        'href': '#',
        'bold': false,
      },
      {
        'title': 'Покупка',
        'href': '#',
        'bold': false,
      },
      {
        'title': 'Обмен',
        'href': '#',
        'bold': false,
      },
      {
        'title': 'trade-in',
        'href': '#',
        'bold': false,
      },
    ],
    [
      {
        'title': 'Сопровождение',
        'href': '#',
        'bold': false,
      },
      {
        'title': 'Оценка объекта',
        'href': '#',
        'bold': false,
      },
    ]
  ];

  subMenuMoreItems: ISubMenuItem[][] = [
    [
      {
        'title': 'Загородная недвижимость',
        'href': "/zagorodnaya-nedvizhimost",
        'bold': true,
      },
      {
        'title': 'Застройщикам',
        'href': "/zastrojshhikam",
        'bold': true,
      },
      {
        'title': 'Офисы',
        'href': "/kontakty",
        'bold': true,
      },
      {
        'title': 'Журнал о недвижимости',
        'href': "/journal",
        'bold': true,
      },
      {
        'title': 'Для агентов',
        'href': "/platform-for-agents",
        'bold': true,
      },
    ],
    [
      {
        'title': 'О компании',
        'href': "/o-kompanii",
        'bold': true,
      },
      {
        'title': 'Центральный офис',
        'href': "/kontakty/centralnyj-ofis",
        'bold': false,
      },
      {
        'title': 'Отзывы',
        'href': "/otzyvy",
        'bold': false,
      },
      {
        'title': 'Вакансии',
        'href': "/vacancies",
        'bold': false,
      },
      {
        'title': 'Программа лояльности',
        'href': "/programma-loyalnosti",
        'bold': false,
      },
    ],
    [
      {
        'title': 'Пресс-центр',
        'href': "/press-centr",
        'bold': true,
      },
      {
        'title': 'Последние публикации',
        'href': "/press-centr",
        'bold': false,
      },
      {
        'title': 'Новости',
        'href': "/novosti/news",
        'bold': false,
      },
      {
        'title': 'Фото и видео',
        'href': "/press-centr/video",
        'bold': false,
      },
    ],
  ];

  subMenuMap = new Map<string, ISubMenuMapItem>([
    ['all', {subMenu: this.allMenuItems, open: false}],
    ['newbuilding', {subMenu: this.subMenuNewBuildingsItems, open: false}],
    ['resale', {subMenu: this.subMenuResaleItems, open: false}],
    ['commercial', {subMenu: this.subMenuCommercialItems, open: false}],
    ['cottage', {subMenu: this.subMenuCottageItems, open: false}],
    ['mortgage', {subMenu: this.subMenuMortgageItems, open: false}],
    ['aboutcompany', {subMenu: this.subMenuAboutCompanyItems, open: false}],
    ['services', {subMenu: this.subMenuServicesItems, open: false}],
    ['more', {subMenu: this.subMenuMoreItems, open: false}],

  ]);

  mobileSubmenuState: { [key: string]: boolean } = {};
  subMenuActiveClass = CLASS_EMPTY
  mobileSubMenuActiveClass = CLASS_EMPTY
  mobileOpenMenu = false;

  constructor(private deviceDetectorService: DeviceDetectorService, private headerService: HeaderService) {
  }

  isOnly(item: IMenuItem): boolean {
    return (!!item.isOnly);
  }

  showMenu(id: string): void {
    this.subMenuActiveClass = CLASS_ACTIVE;
    this.subMenuMap.forEach((value, key, map) => {
      value.open = key === id ? !value.open : false;
      map.set(key, value);
    });
  }

  hideMenu(): void {
    this.subMenuActiveClass = CLASS_EMPTY;
  }

  hideMenuMobile(): void {
    this.mobileOpenMenu = false;
    this.mobileSubMenuActiveClass = CLASS_EMPTY;
  }

  isMobile(): boolean {
    return this.deviceDetectorService.isMobile();
  }

  isActive(item: ISubMenuMapItem): string {
    return item.open ? CLASS_ACTIVE : CLASS_EMPTY;
  }

  showMobileMenu(): void {
    this.mobileOpenMenu = true;
    this.mobileSubMenuActiveClass = CLASS_ACTIVE;
  }

  getSubMenuColumn(id: string): ISubMenuItem[][]|null {
    return this.subMenuMap.get(id)?.subMenu ?? null;
  }

  showMobileSubMenu(menuId: string, event: MouseEvent): void {
    event.stopPropagation();
    // Проверяем текущее состояние дочернего меню
    const isSubmenuActive = this.mobileSubmenuState[menuId];

    // Закрываем все дочерние меню, кроме текущего
    for (const key in this.mobileSubmenuState) {
      if (key !== menuId) {
        this.mobileSubmenuState[key] = false;
      }
    }

    // Переключаем текущее состояние дочернего меню
    this.mobileSubmenuState[menuId] = !isSubmenuActive;

    // Устанавливаем класс активности
    this.subMenuActiveClass = this.mobileSubmenuState[menuId] ? 'active' : 'active';
  }

  getBoldClass(bold: boolean): string {
    return bold ? '__new__header__submenu-link--bold' : '';
  }

  showCalltouchWidget(): void {
    this.headerService.showCalltouchWidget();
  }
}
